export default {
  loginUrl: 'https://staff.medbanks-test.com/login',
  baseUrl: 'https://api-gateway.medbanks-test.com',
  wsUrl: 'wss://api-gateway.medbanks-test.com/ws/connect',
  h5Url: 'http://mservice.medbanks-test.com',

  /** @name 知识库-模版管理 */
  h5TemplateUrl: 'https://spcare.medbanks-test.com/activities/activities-H5/qaLanding?templateId=',
};
